// For Development
// export default `http://advisoryapp.eastus.cloudapp.azure.com:8080`;
// export default `http://dev.savart.com`;
// export default `https://dev.savart.com/workflow`;

//export default `http://44.204.134.75/customer/workflow`;

// For Production
export default ``;
